import { Skeleton } from '@/design-system/skeleton';
import { PreviewRowSkeleton } from './PreviewRowSkeleton';

export const PreviewSectionSkeleton = ({ rows = 5 }: { rows?: number }) => {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-3">
        <Skeleton className="h-5 w-[160px]" />
        <div className="h-[2px] w-full bg-skeleton-divider" />
      </div>

      {Array.from({ length: rows }).map((_, i) => (
        <PreviewRowSkeleton key={i} />
      ))}
    </div>
  );
};
